<div class="account-summary" [class.account-summary--small]="size === 'small'" (click)="openModal()">
    <!-- START: NEW SMALL SIZE LAYOUT -->
    <ng-container *ngIf="size === 'small'">
        <div class="small-header">
            <div class="small-title">Accounts Summary</div>
            <div class="small-actions">
                <ng-container *ngIf="isEditMode">
                    <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()"
                        cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                        <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit" />
                    </div>
                    <app-widget-edit [editTrigger]="editTrigger" [index]="index"
                        [activeDropdownIndex]="activeDropdownIndex" [getAvailableSizes]="getAvailableSizes"
                        [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
                        [toggleSizeDropdown]="toggleSizeDropdown">
                    </app-widget-edit>
                </ng-container>

                <ng-container *ngIf="isAddMode">
                    <img class="add-widget-btn no-dark-filter" src="assets/icons/img_frame-1171275385.png" alt="Add"
                        (click)="addWidget.emit(); $event.stopPropagation()" />
                </ng-container>
            </div>
        </div>

        <div class="small-body">
            <div class="info-group">
                <img src="assets/icons/usericon.svg" class="group-icon" />
                <div class="info-labels">
                    <div class="label">All Accounts</div>
                    <div class="label">Balance</div>
                </div>
            </div>

            <div class="balance-group">
                <div class="amount">{{ totalBalance }}</div>
                <div class="currency">INR</div>
            </div>
        </div>
    </ng-container>
    <!-- END: NEW SMALL SIZE LAYOUT -->

    <!-- START: REGULAR SIZE LAYOUT (MEDIUM/HALF/FULL) -->
    <ng-container *ngIf="size !== 'small'">
        <!-- Header -->
        <div class="account-summary__header">
            <div class="account-summary__title">{{ title }}</div>

            <div class="header-right">
                <ng-container *ngIf="isEditMode">
                    <!-- Edit Pencil (only in edit mode) -->
                    <div class="pencil-wrapper" (click)="toggleSizeDropdown(index, $event); $event.stopPropagation()"
                        cdkOverlayOrigin #editTrigger="cdkOverlayOrigin">
                        <img src="assets/icons/img-pencil.svg" class="pencil-icon" alt="Edit size" />
                    </div>
                    <!-- Size Dropdown -->
                    <app-widget-edit [editTrigger]="editTrigger" [index]="index"
                        [activeDropdownIndex]="activeDropdownIndex" [getAvailableSizes]="getAvailableSizes"
                        [changeWidgetSize]="changeWidgetSize" [removeWidget]="removeWidget"
                        [toggleSizeDropdown]="toggleSizeDropdown">
                    </app-widget-edit>
                </ng-container>

                <ng-container *ngIf="isAddMode">
                    <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                        alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
                </ng-container>
            </div>
        </div>

        <div class="account-summary__body">
            <div class="account-summary__main">
                <div class="account-info">
                    <div class="account-number">
                        <img class="user-icon" src="assets/icons/usericon.svg" alt="User" />
                        <span>{{ currentAccount.number }}</span>
                    </div>
                    <div class="balance-container">
                        <div class="balance-amount">{{ currentAccount.balance }}</div>
                        <div class="balance-currency">{{ currentAccount.currency }}</div>
                    </div>
                </div>

                <div class="nav-controls">
                    <div class="nav-btn" [class.disabled]="!canGoPrev"
                        (click)="$event.stopPropagation(); canGoPrev && prev()">
                        <img src="assets/icons/img_image.svg" alt="Prev" />
                    </div>
                    <div class="nav-btn" [class.disabled]="!canGoNext"
                        (click)="$event.stopPropagation(); canGoNext && next()">
                        <img src="assets/icons/img_arrow-right.svg" alt="Next" />
                    </div>
                </div>
            </div>

            <div class="divider"></div>

            <div class="transactions-list" (click)="toggleRecentTransactions($event)" cdkOverlayOrigin
                #moreTrigger="cdkOverlayOrigin">
                <ng-container *ngIf="visibleTransactions.length > 0; else noData">
                    <div class="transaction-item" *ngFor="let item of visibleTransactions">
                        <div class="transaction-icon-wrapper" [class.withdraw]="item.type === 'withdraw'"
                            [class.deposit]="item.type === 'deposit'">
                            <img [src]="item.icon" class="transaction-icon" alt="Transaction" />
                        </div>
                        <div class="transaction-details">
                            <div class="transaction-label" [title]="item.label">{{ item.label }}</div>
                            <div class="transaction-subtitle">
                                <span class="date">{{ item.date }}</span>
                                <span class="time">{{ item.time }}</span>
                            </div>
                        </div>
                        <div class="transaction-amount-wrapper">
                            <div class="transaction-amount" [class.amount-credit]="item.type === 'deposit'"
                                [class.amount-debit]="item.type === 'withdraw'">{{ item.type === 'deposit' ? '+ ' : ''
                                }}₹{{ item.amount.replace('₹','') }}</div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #noData>
                    <div class="no-transactions-container">
                        <div class="no-transactions-alert">
                            <img src="assets/icons/information.svg" class="info-icon" alt="Info"
                                onerror="this.src='assets/icons/usericon.svg'" />
                            <span>No transactions found for this account.</span>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>

        <!-- Recent Transactions Dropdown -->
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="moreTrigger"
            [cdkConnectedOverlayOpen]="isRecentTransactionsOpen" [cdkConnectedOverlayPositions]="overlayPositions"
            (overlayOutsideClick)="closeRecentTransactions()">
            <div class="recent-transactions" (click)="$event.stopPropagation()">
                <div class="frame">
                    <div class="component">
                        <div class="title">Recent transactions</div>
                        <footer class="footer" (click)="closeRecentTransactions($event)">
                            <div class="button">Done</div>
                        </footer>
                    </div>

                    <div class="frame-3">
                        <div class="component-2" *ngFor="let tx of paginatedRecentTransactions">
                            <div [class]="tx.type === 'withdraw' ? 'component-3' : 'component-4'"></div>
                            <div class="frame-4">
                                <div class="frame-wrapper">
                                    <div class="frame-5">
                                        <div class="products-value">{{tx.label}}</div>
                                        <div class="div-2">
                                            <div class="date-range">{{tx.date}}</div>
                                            <div class="date-range">{{tx.time}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="component-wrapper">
                                    <div class="div-2">
                                        <div [class]="tx.type === 'withdraw' ? 'views-value' : 'text-wrapper'">
                                            {{ tx.type === 'deposit' ? '+ ' : '' }}{{tx.amount}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="view-all-footer" (click)="navigateToTransactions($event)">
                        <span>View all transactions</span>
                        <img src="assets/icons/arrow-rightp.svg" alt="arrow" class="arrow-icon" *ngIf="!isDarkMode" />
                        <img src="assets/icons/img-arrow-right-2.svg" alt="arrow" class="arrow-icon"
                            *ngIf="isDarkMode" />
                    </div>
                </div>
            </div>
        </ng-template>
    </ng-container>
    <!-- END: REGULAR SIZE LAYOUT -->
</div>